<template>
  <transition name="fade">
    <div
      v-if="show"
      class="at-notification at-notification--with-message at-notification--info"
      style="position: fixed; bottom: 30px; right: 15px; width: 300px"
    >
      <img src="/static/lang/img/bird.png" class="bird" />
      <div class="at-notification__content">
        <p class="at-notification__title">{{ title }}</p>
        <p class="at-notification__message" style="margin: 0">{{ content }}</p>
      </div>
      <i class="icon icon-x at-notification__close" @click="close"></i>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["mapClick"],
  watch: {
    // отслеживание кликов по карте для скрытия окна
    mapClick() {
      this.close();
    },
  },
  computed: {
    show() {
      return this.$store.getters.getNotify.show;
    },
    title() {
      return this.$store.getters.getNotify.title;
    },
    content() {
      var rex = /(<([^>]+)>)/gi;
      return this.$store.getters.getNotify.content.replace(rex, "");
    },
  },
  methods: {
    close() {
      this.$store.getters.getNotify.show = false;
    },
  },
};
</script>

<style scoped>
.at-notification__title {
  margin: 0;
  font-weight: normal;
  font-family: "Izhitsa Cyrillic", sans-serif;
  font-size: 120%;
  color: red;
}

.bird {
  width: 100px;
  height: 88px;
  padding-right: 10px;
  filter: brightness(0.25) drop-shadow(rgba(17, 17, 17, 0.4) 2px 2px 2px);
}
</style>